import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

import ConfirmDialogExtension from '../confirmDialog/index.js';

class InvoiceForm {
    constructor() {
        this.uncompletedDocumentSelector = '#uncompletedDocument';
        this.tryOpenInlineAdd();
        this.initInvoiceDetail();
        this.initInvoiceItem();
        this.initInvoiceItemAutocomplete();
        this.initInvoiceItemRowBehavior();
        this.initSerialNumberEvents();
        this.initInvoiceGetContactDetail();

        this.lastQuery = '';
        this.activeRequest = null;
        this.isLoading = false;
        this.debounceTimer = null;
    }

    tryOpenInlineAdd() {
        const gridWrapper = document.querySelector('.datagrid-wrapper');
        const completeBtn = document.querySelector('#snippet-editTabs-tabContent-polozky-tabControl-grid-grid-grid');

        if (!gridWrapper || !completeBtn) return;

        if (gridWrapper.querySelector('.datagrid-row-inline-add')){
            const newInput = document.getElementById('invoice-item-name');
            if (newInput) {
                const active = document.activeElement;
                const isInputFocused = active && (
                    active.tagName === 'INPUT' ||
                    active.tagName === 'TEXTAREA' ||
                    active.isContentEditable
                );

                if (!isInputFocused) {
                    newInput.focus();
                }
                // obs.disconnect();
            }
            return;
        }

        const showInlineAddLink = gridWrapper.querySelector('a[href*="showInlineAdd"]');
        if (showInlineAddLink) {
            naja.uiHandler.clickElement(showInlineAddLink);
        }
    }

    initInvoiceDetail() {
        this.dateIssueInput = document.getElementById('date-issue');
        this.maturityInput = document.getElementById('maturity');
        this.dateMaturityInput = document.getElementById('date-maturity');

        if (this.dateIssueInput && this.maturityInput && this.dateMaturityInput) {
            if (!this.maturityInput.classList.contains('input-listener-attached')) {
                this.maturityInput.classList.add('input-listener-attached');
                this.maturityInput.addEventListener('input', () => this.updateDateMaturity());
            }

            if (!this.dateMaturityInput.classList.contains('input-listener-attached')) {
                this.dateMaturityInput.classList.add('input-listener-attached');
                this.dateMaturityInput.addEventListener('input', () => this.updateMaturity());
            }
        }
    }

    initInvoiceItem() {
        this.invoiceItemRepayment = document.getElementById('invoice-item-repayment');
        this.invoiceItemCount = document.getElementById('invoice-item-count');
        this.invoiceItemTaxRate = document.getElementById('invoice-item-tax-rate');
        this.invoiceItemPrice = document.getElementById('invoice-item-price');
        this.invoiceItemDiscount = document.getElementById('invoice-item-discount');
        this.invoiceItemPriceBase = document.getElementById('invoice-item-price-base');
        this.invoiceItemPricePurchase = document.getElementById('invoice-item-price-purchase')
        this.invoiceItemPricePurchaseBase = document.getElementById('invoice-item-price-purchase-base');
        this.invoiceItemPriceSale = document.getElementById('invoice-item-price-sale');
        this.invoiceItemPriceSaleTax = document.getElementById('invoice-item-price-sale-tax');
        this.invoiceItemPriceSaleTotal = document.getElementById('invoice-item-price-sale-total');
        this.invoiceItemPriceTotal = document.getElementById('invoice-item-price-total');
        this.invoiceItemCountAvailable = document.getElementById('invoice-item-count-available');
        this.invoiceItemFees = document.getElementById('invoice-item-fees');

        if (this.invoiceItemRepayment && this.invoiceItemRepayment.classList.contains('form-control')) {
            this.invoiceItemRepayment.classList.remove('form-control');
        }
        if (this.invoiceItemRepayment && this.invoiceItemRepayment.classList.contains('form-control-sm')) {
            this.invoiceItemRepayment.classList.remove('form-control-sm');
        }

        var inputs = [
            this.invoiceItemCount,
            this.invoiceItemTaxRate,
            this.invoiceItemPrice,
            this.invoiceItemDiscount,
            this.invoiceItemPriceSale,
            this.invoiceItemPricePurchase
        ];

        inputs.forEach(input => {
            if (input && !input.classList.contains('price-listener-attached')) {
                input.classList.add('price-listener-attached');
                input.addEventListener('input', () => this.updateInvoiceItemPrice());
            }
        });

        if (this.invoiceItemCount && this.invoiceItemCountAvailable) {
            ['input', 'change', 'blur'].forEach(eventType => {
                this.invoiceItemCount.addEventListener(eventType, () => this.validateItemCount());
            });
        }
    }

    validateItemCount() {
        var count = parseInt(this.invoiceItemCount?.value || '0', 10);
        var countAvailable = parseInt(this.invoiceItemCountAvailable?.value || '0', 10);

        if (!isNaN(count) && !isNaN(countAvailable) && count > countAvailable) {
            this.invoiceItemCount.value = countAvailable;
            this.updateInvoiceItemPrice();
            alert(`Není dostatek zboží skladem. Maximální počet upraven na ${countAvailable}.`);
        }
    }

    initInvoiceItemAutocomplete() {
        this.invoiceItemNameInput = document.getElementById('invoice-item-name');
        if (!this.invoiceItemNameInput || this.invoiceItemNameInput.classList.contains('autocomplete-attached')) return;

        this.invoiceItemNameInput.classList.add('autocomplete-attached');
        this.suggestionsContainer = document.getElementById('suggestions-container') || this.createSuggestionsContainer();

        this.invoiceItemNameInput.addEventListener('click', () => {
            this.loadSuggestions(true);
        });

        // Upravená implementace pro klávesovou navigaci
        this.invoiceItemNameInput.addEventListener('keydown', event => {
            // Navigace pomocí šipek
            if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
                event.preventDefault(); // Zabránit posunu kurzoru v textovém poli

                if (this.suggestionsContainer.style.display === 'flex') {
                    var items = this.suggestionsContainer.querySelectorAll('.list-group-item');
                    if (items.length === 0) return;

                    var highlighted = this.suggestionsContainer.querySelector('.list-group-item.highlighted');
                    let index = -1;

                    if (highlighted) {
                        index = Array.from(items).indexOf(highlighted);
                        highlighted.classList.remove('highlighted');
                        highlighted.style.background = '#fff';

                        if (event.key === 'ArrowDown') {
                            index = (index + 1) % items.length;
                        } else {
                            index = (index - 1 + items.length) % items.length;
                        }
                    } else {
                        index = event.key === 'ArrowDown' ? 0 : items.length - 1;
                    }

                    var newHighlighted = items[index];
                    newHighlighted.classList.add('highlighted');
                    newHighlighted.style.background = '#f0f0f0';

                    // Zajistíme, že je vybraná položka viditelná
                    newHighlighted.scrollIntoView({block: 'nearest'});
                }
                return;
            }

            // Výběr položky pomocí klávesy Enter
            if (event.key === 'Enter') {
                var highlighted = this.suggestionsContainer.querySelector('.list-group-item.highlighted');

                if (highlighted && this.suggestionsContainer.style.display === 'flex') {
                    event.preventDefault();
                    highlighted.click(); // Spustí kliknutí na zvýrazněnou položku
                    return;
                } else {
                    event.preventDefault();
                    this.invoiceItemCount.value = 1;
                    this.suggestionsContainer.innerHTML = '';
                    this.suggestionsContainer.style.display = 'none';
                    this.invoiceItemCount.select();
                    this.showAddProductModal();
                }
            }
        });

        this.invoiceItemNameInput.addEventListener('keyup', (event) => {
            // Přeskočit tyto klávesy, protože jsou zpracovány v keydown
            if (['ArrowDown', 'ArrowUp', 'Enter'].includes(event.key)) return;
            this.loadSuggestions();
        });

        this.invoiceItemNameInput.addEventListener('blur', () => {
            setTimeout(() => {
                this.suggestionsContainer.innerHTML = '';
                this.suggestionsContainer.style.display = 'none';
            }, 200);
        });
    }

    initInvoiceGetContactDetail(){
        this.invoiceIssuedForInput = document.getElementById('invoice-issued-for');

        if (!this.invoiceIssuedForInput) {
            return;
        }

        this.invoiceIssuedForInput.onchange = () => {
            const contactId = this.invoiceIssuedForInput.value;
            const provide = this.invoiceIssuedForInput.getAttribute('data-provide');
            if (contactId) {
                naja.makeRequest('POST', provide, {contactId}, {history: false})
                .then(response => {
                    document.getElementById('maturity').value = response.maturity || 30;
                    this.updateDateMaturity();
                })
            }
        };
    }

    showAddProductModal() {
        var confirmDialog = new ConfirmDialogExtension();
        confirmDialog.showConfirmDialog(
            'Tento produkt nebyl nalezen. Chcete vytvořit novou kartu produktu?',
            (newTab) => {
                var productName = encodeURIComponent(this.invoiceItemNameInput.value);
                var url = `/main/store/catalog?name=${productName}`;

                window.open(url, '_blank');
            },
            () => {
                this.invoiceItemNameInput.focus();
            },
            true
        );
    }

    initInvoiceItemRowBehavior() {
        document.querySelectorAll('.datagrid-row-inline-add, .datagrid-row-inline-edit').forEach(row => {
            // Získat všechny vstupy kromě submit tlačítka
            var inputs = row.querySelectorAll('input:not([type="submit"]), select, textarea');
            var submitButton = row.querySelector('input[name="inline_add[submit]"], input[name="inline_edit[submit]"]');
            var form = row.closest('form');

            if (submitButton && !submitButton.classList.contains('submit-listener-attached')) {
                submitButton.classList.add('submit-listener-attached');

                // Zabráníme standardnímu zpracování NAJA - zachytíme událost před ní
                submitButton.addEventListener('click', this.handleSubmitValidation.bind(this), true);
            }

            inputs.forEach(input => {
                if (!input.classList.contains('enter-listener-attached')) {
                    input.classList.add('enter-listener-attached');

                    // Zachycení před standardním zpracováním
                    input.addEventListener('keydown', this.handleEnterKeyValidation.bind(this, row, submitButton), true);
                }
            });
        });

        // Zbytek metody zůstává nezměněn
        if (!naja.__inlineAddFocusBound) {
            naja.addEventListener('complete', () => {
                var observer = new MutationObserver((mutations, obs) => {
                    var newInput = document.getElementById('invoice-item-name');
                    if (newInput) {
                        const active = document.activeElement;
                        const isInputFocused = active && (
                            active.tagName === 'INPUT' ||
                            active.tagName === 'TEXTAREA' ||
                            active.isContentEditable
                        );

                        if (!isInputFocused) {
                            newInput.focus();
                        }
                        obs.disconnect();
                    }
                });

                observer.observe(document, {childList: true, subtree: true});
            });

            naja.__inlineAddFocusBound = true;
        }
    }

// Aktualizace metody initSerialNumberEvents pro komunikaci s nově vytvořenými funkcemi
    initSerialNumberEvents() {
        window.serialNumberModalState = {
            isModalOpening: false,
            isModalOpen: false,
            lastInput: null
        };


        // Přidat globální posluchač pro klávesu Enter
        document.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === 'Tab') {
                // Kontrola, zda se jedná o pole sériových čísel
                var isSerialNumberField =
                    event.target.id === 'invoice-item-serial-number' ||
                    event.target.name === 'inline_add[serialNumber]' ||
                    event.target.name === 'inline_edit[serialNumber]';

                // Kontrola, zda je otevírané nebo otevřené modální okno
                var isModalActive =
                    window.serialNumberModalState?.isModalOpening ||
                    window.serialNumberModalState?.isModalOpen;

                // Kontrola, zda aktuální pole odpovídá poslednímu poli sériových čísel
                var isLastField =
                    window.serialNumberModalState?.lastInput === event.target;

                // Blokovat klávesu Enter pouze pokud:
                // 1. Je to pole sériových čísel A
                // 2. Modální okno je aktivní nebo se otevírá A
                // 3. Aktuální pole odpovídá poslednímu poli sériových čísel
                if (isSerialNumberField && isModalActive && isLastField) {
                    console.log('Blokuji klávesu Enter na poli sériových čísel během práce s modálním oknem');
                    event.preventDefault();
                    event.stopPropagation();
                    return false;
                }
            }
        }, true);

        if (document.body.hasAttribute('serial-number-events-initialized')) {
            return;
        }
        document.body.setAttribute('serial-number-events-initialized', 'true');

        document.addEventListener('click', (e) => {
            var target = e.target;
            if (target.id === 'invoice-item-serial-number' && !target.disabled) {
                e.preventDefault();
                this.openSerialNumberModal(target);
            }
        });

        if (!window.najaSerialNumberListenerInitialized) {
            window.najaSerialNumberListenerInitialized = true;

            // naja.addEventListener('success', (event) => {
            //     var {payload} = event.detail;
            //
            //     if (payload && payload.serialNumbers !== undefined && window.lastClickedSerialNumberInput) {
            //         window.lastClickedSerialNumberInput.value = payload.serialNumbers;
            //         // Aktualizovat počet položek podle počtu zadaných sériových čísel
            //
            //         const serialNumbers = payload.serialNumbers;
            //         const count = serialNumbers.split(',').filter(sn => sn.trim() !== '').length;
            //
            //         console.log('ASDASD');
            //         console.log(window.lastClickedSerialNumberInput);
            //         console.log(window.lastClickedSerialNumberInput.closest('tr'));
            //         console.log(window.lastClickedSerialNumberInput.closest('tr').querySelector('#invoice-item-count'));
            //         window.lastClickedSerialNumberInput.closest('tr').querySelector('#invoice-item-count').value = count;
            //
            //         this.updateInvoiceItemPrice();
            //     }
            // });
        }
    }

    // Upravme metodu zpracování sériových čísel při zavření modálního okna
    processSerialNumberSelection(modal) {
        // Implementace zpracování výběru sériových čísel...

        // Nastavit příznak aktualizace sériových čísel
        window.serialNumbersUpdated = true;

        // Další kód pro zpracování sériových čísel...
    }



    // Ověření, zda existuje tlačítko pro odeslání před jeho použitím
    handleSubmitValidation(event) {
        // Zkontrolovat, zda je splněna podmínka pro sériová čísla
        var serialNumberInput = document.getElementById('invoice-item-serial-number');

        // Pokud byl formulář nedávno odeslán prostřednictvím modálního okna sériových čísel, povolit odeslání
        if (window.serialNumbersUpdated === true) {
            window.serialNumbersUpdated = false;
            return true;
        }

        // Pokud je pole sériových čísel povinné, ale prázdné, zabránit odeslání
        if (serialNumberInput && !serialNumberInput.disabled && (!serialNumberInput.value || serialNumberInput.value.trim() === '')) {
            event.preventDefault();
            event.stopPropagation();

            // Zobrazit upozornění
            alert('Prosím vyplňte sériové číslo.');

            // Otevřít modální okno pro výběr sériových čísel
            this.openSerialNumberModal(serialNumberInput);

            return false;
        }

        // Kontrola, zda existuje storeCard
        var storeCardId = document.getElementById('invoice-item_add-store-card')?.value;
        if (!storeCardId || storeCardId === '') {
            event.preventDefault();
            event.stopPropagation();

            this.showAddProductModal();
            return false;
        }

        // Ostatní kontroly
        return this.checkCountAndCountAvailable();
    }


    handleEnterKeyValidation(row, submitButton, event) {
        if (event.key === 'Enter') {
            event.preventDefault();

            // Získání všech vstupních polí v řádku, která nejsou readonly nebo disabled
            var editableInputs = Array.from(row.querySelectorAll('input:not([type="submit"]), select, textarea'))
                .filter(input => !input.readOnly && !input.disabled);

            // Zjištění aktuálního vstupního pole a jeho pozice v seznamu
            var currentInput = event.target;
            var currentIndex = editableInputs.indexOf(currentInput);

            // Kontrola, zda je aktuální pole poslední editovatelné pole v řádku
            var isLastInput = currentIndex === editableInputs.length - 1;

            if (isLastInput) {
                // Jsme v posledním vstupním poli - uložíme řádek
                if (this.checkCountAndCountAvailable()) {
                    if (submitButton && row.dataset.submitted !== 'true') {
                        row.dataset.submitted = 'true';
                        var addLink = document.querySelector('.row-group-actions .datagrid-toolbar .datagrid-settings a[title="Add"]');
                        var completeBtn2 = document.querySelector(this.uncompletedDocumentSelector);

                        var handleNajaComplete = () => {
                            if (addLink && !completeBtn2) addLink.click();
                            naja.removeEventListener('complete', handleNajaComplete);
                        };

                        naja.addEventListener('complete', handleNajaComplete);
                        if (submitButton) {
                            submitButton.click(); // spustí odeslání přes Naja
                        }
                    }
                } else {
                    event.stopPropagation();
                    event.stopImmediatePropagation();
                    return false;
                }
            } else {
                // Nejsme v posledním vstupním poli - přesuneme fokus na další editovatelné pole
                var nextInput = editableInputs[currentIndex + 1];
                if (nextInput) {
                    nextInput.focus();

                    // Pokud jde o textové vstupní pole, vyberte celý text
                    if (nextInput.type === 'text' || nextInput.type === 'number' || nextInput.tagName.toLowerCase() === 'textarea') {
                        nextInput.select();
                    }

                    // Speciální zpracování pro pole sériového čísla
                    if (nextInput.id === 'invoice-item-serial-number' && !nextInput.disabled) {
                        // Simulovat kliknutí na pole sériového čísla po malém zpoždění
                        setTimeout(() => {
                            // Vyvolat událost kliknutí na pole sériového čísla
                            this.openSerialNumberModal(nextInput);
                        }, 50);
                    }
                }
            }
        } else if (event.key === 'Tab') {
            // Zjištění aktuálního vstupního pole a jeho pozice v seznamu
            var currentInput = event.target;

            // Kontrola, zda se jedná o pole sériových čísel
            var isBeforeSerialNumberField =
                currentInput.name === 'inline_add[pricePurchaseBase]' ||
                currentInput.name === 'inline_edit[pricePurchaseBase]';

            var serialNumberInput = document.getElementById('invoice-item-serial-number');

            // Pokud je to pole sériových čísel a má prázdnou hodnotu, otevřeme modální okno
            if (isBeforeSerialNumberField && !serialNumberInput.disabled) {

                // Pro Tab necháme standardní chování (přechod na další pole), ale otevřeme modální okno
                // Inicializace stavu modálního okna, pokud ještě neexistuje
                if (!window.serialNumberModalState) {
                    window.serialNumberModalState = {
                        isModalOpening: false,
                        isModalOpen: false,
                        lastInput: null
                    };
                }

                // Kontrola, zda již není otevřené modální okno
                var isModalActive =
                    window.serialNumberModalState.isModalOpening ||
                    window.serialNumberModalState.isModalOpen;

                // Pokud modální okno ještě není aktivní, otevřeme ho
                if (!isModalActive) {
                    this.openSerialNumberModal(serialNumberInput);
                }
            }
        }
    }


// Upravme metodu pro otevření modálního okna, aby nastavila stav
    openSerialNumberModal(serialNumberInput) {
        if (!serialNumberInput || serialNumberInput.disabled) return;

        var serialNumbers = serialNumberInput.value || '';
        var url = serialNumberInput.getAttribute('data-link');

        if (!url) return;

        var updatedUrl = url.replace('SERIAL_NUMBERS', encodeURIComponent(serialNumbers));

        // Nastavit stav otevírání modálního okna
        if (!window.serialNumberModalState) {
            window.serialNumberModalState = {
                isModalOpening: false,
                isModalOpen: false,
                lastInput: null
            };
        }

        // Nastavit stav otevírání modálního okna
        window.serialNumberModalState.isModalOpening = true;
        window.serialNumberModalState.lastInput = serialNumberInput;

        // Uložit referenci na input pole pro pozdější použití
        window.lastClickedSerialNumberInput = serialNumberInput;

        // Uložit referenci na počet položek
        this.expectedSerialNumberCount = parseInt(this.invoiceItemCount?.value || '1', 10);

        // Resetovat příznaky
        window.serialNumberWarningShown = false;
        window.serialNumbersUpdated = false;

        naja.makeRequest('GET', updatedUrl, null, {
            history: false
        }).then(() => {
            var modalId = 'modal-serial-number';
            var modal = document.getElementById(modalId);

            if (modal) {
                var bsModal = new bootstrap.Modal(modal);

                // Přidat posluchač událostí pro zobrazení modálního okna
                modal.addEventListener('shown.bs.modal', () => {
                    window.serialNumberModalState.isModalOpen = true;
                    window.serialNumberModalState.isModalOpening = false;
                });

                // Přidat posluchač událostí pro zavření modálního okna
                modal.addEventListener('hidden.bs.modal', () => {
                    window.serialNumberModalState.isModalOpen = false;

                    // Přidat jednorázový posluchač na dokončení NAJA požadavku
                    if (typeof naja !== 'undefined' && window.serialNumbersUpdated) {
                        var completeHandler = () => {
                            naja.removeEventListener('complete', completeHandler);

                            // Najít tlačítko pro odeslání formuláře
                            var addButton = document.querySelector('input[name="inline_edit[submit]"]');
                            if (!addButton) {
                                addButton = document.querySelector('input[name="inline_add[submit]"]');
                            }
                            if (addButton) {
                                this.simulateClickAndSubmit(addButton);
                            }
                        };

                        naja.addEventListener('complete', completeHandler);
                    }
                });

                bsModal.show();

                // Inicializace posluchačů událostí pro modální okno
                setTimeout(() => {
                    this.initSerialNumberModalEvents(modal);
                    this.focusFirstSelect2InModal(modal);
                }, 500);
            }
        }).catch(error => {
            // Resetovat stav v případě chyby
            window.serialNumberModalState.isModalOpening = false;
            console.error('Chyba při načítání modálního okna sériového čísla:', error);
        });
    }


// Rozšířená metoda pro zaměření na Select2
    focusFirstSelect2InModal(modal) {
        setTimeout(() => {
            var select2Element = modal.querySelector('select.select2-hidden-accessible');
            if (select2Element) {
                try {
                    $(select2Element).select2('open');
                } catch (e) {
                    console.error('Chyba při zaměřování Select2:', e);

                    // Záložní metoda: Simulace kliknutí na Select2 kontejner
                    var select2Container = modal.querySelector('.select2-container');
                    if (select2Container) {
                        select2Container.click();
                    }
                }
            }
        }, 300);
    }


    // Upravená metoda pro inicializaci událostí v modálním okně sériových čísel
    initSerialNumberModalEvents(modal) {
        // Najít formulář v modálním okně
        var form = modal.querySelector('form');
        if (!form) return;

        // Najít tlačítko submit
        var submitButton = form.querySelector('button[name="submitBack"], input[name="submitBack"]');
        if (!submitButton) return;

        // Najít select2 element pro sériová čísla
        var serialSelect = form.querySelector('select.select2-hidden-accessible');
        if (!serialSelect) return;

        // Uložit počet očekávaných sériových čísel
        var expectedCount = this.expectedSerialNumberCount || 1;

        // Příznak, zda bylo zobrazeno upozornění o neúplném počtu sériových čísel
        window.serialNumberWarningShown = window.serialNumberWarningShown || false;

        // Funkce pro aktualizaci počtu záznamů v elementech .currentSnCount
        const updateSelect2Count = () => {
            // Pokud existuje select2 a je inicializován
            if ($(serialSelect).length && $(serialSelect).data('select2')) {
                // Získání počtu všech záznamů
                const totalCount = $(serialSelect).find('option').length;
                // Získání počtu vybraných záznamů
                // const selectedCount = $(serialSelect).select2('data').length;

                // Najdeme elementy pro zobrazení počtů
                const startCountElement = form.querySelector('.startSnCount');
                const currentCountElements = form.querySelectorAll('.currentSnCount');

                // Aktualizace počátečního počtu
                if (startCountElement) {
                    startCountElement.textContent = totalCount ? 1 : 0;
                }

                // Aktualizace aktuálního počtu a celkového počtu
                if (currentCountElements.length >= 2) {
                    currentCountElements[0].textContent = totalCount;
                    currentCountElements[1].textContent = totalCount;
                }
            }
        };

        // Inicializace počítadla po načtení select2
        setTimeout(() => {
            updateSelect2Count();

            // Přidání posluchače událostí pro všechny změny v select2
            $(serialSelect).on('change select2:select select2:unselect', function() {
                setTimeout(() => {
                    updateSelect2Count();
                }, 100);
            });
        }, 100);


        // Nastavit posluchač události pro select2 při změně hodnoty
        $(serialSelect).on('select2:select', (e) => {
            // Po každém přidání sériového čísla zkontrolujeme počet
            setTimeout(() => {
                var selectedOptions = $(serialSelect).select2('data');
                var currentCount = selectedOptions.length;

                // Pokud jsme dosáhli očekávaného počtu, přesuneme fokus na tlačítko Uložit
                if (currentCount >= expectedCount) {
                    submitButton.focus();
                }
            }, 100);
        });

        // Nastavit posluchač klávesy Enter pro select2 kontejner
        $(serialSelect).on('keydown', (event) => {
            if (event.key === 'Enter') {
                event.preventDefault();
                event.stopPropagation();

                var selectedOptions = $(serialSelect).select2('data');
                var currentCount = selectedOptions.length;

                // Zkontrolovat počet sériových čísel
                if (currentCount < expectedCount) {
                    if (!window.serialNumberWarningShown) {
                        window.serialNumberWarningShown = true;
                        alert('Pozor, nezadal jste všechna sériová čísla, pokud je to v pořádku, pokračujte s uložením.');
                    }
                }

                // Přesunout fokus na tlačítko Uložit
                submitButton.focus();
            }
        });

        // Přidat posluchače události pro tlačítko Uložit
        if (!submitButton.classList.contains('sn-submit-handler')) {
            submitButton.classList.add('sn-submit-handler');

            // Přidat posluchač události pro kliknutí na tlačítko Uložit
            submitButton.addEventListener('click', (event) => {

                // Počet vybraných sériových čísel
                var selectedOptions = $(serialSelect).select2('data');
                var selectedCount = selectedOptions.length;

                // Aktualizovat hodnotu v původním input poli pro sériová čísla
                if (window.lastClickedSerialNumberInput) {
                    // Získat hodnoty vybraných sériových čísel
                    var serialNumbers = selectedOptions.map(option => option.text || option.id).join(',');
                    window.lastClickedSerialNumberInput.value = serialNumbers;

                    let querySelector = window.lastClickedSerialNumberInput.closest('tr').querySelector('#document-item-count');
                    if (!querySelector) {
                        querySelector = window.lastClickedSerialNumberInput.closest('tr').querySelector('#invoice-item-count');
                    }
                    querySelector.value = selectedCount;

                    // Nastavit hodnotu počtu položek podle počtu sériových čísel
                    // if (selectedCount > 0 && this.invoiceItemCount) {
                    //     this.invoiceItemCount.value = selectedCount;
                        this.updateInvoiceItemPrice();
                    // }

                    // Příznak, že došlo k aktualizaci sériových čísel
                    window.serialNumbersUpdated = true;

                    var addButton = document.querySelector('input[name="inline_edit[submit]"]');
                    if (!addButton) {
                        addButton = document.querySelector('input[name="inline_add[submit]"]');
                    }
                    if (addButton) {
                        // Simulovat kliknutí na tlačítko pro přidání
                        var completeHandler = () => {
                            console.log('NAJA požadavek dokončen, odesílám formulář');
                            naja.removeEventListener('complete', completeHandler);
                            this.simulateClickAndSubmit(addButton);
                        };

                        naja.addEventListener('complete', completeHandler);
                    }
                }
            });
        }

        // Přidat posluchač události pro stisk klávesy Enter, když je fokus na tlačítku
        submitButton.addEventListener('keydown', (event) => {
            if (event.key === 'Enter') {
                event.preventDefault();
                submitButton.click();
            }
        });
    }

// Nová metoda pro simulaci kliku a odeslání formuláře
    simulateClickAndSubmit(button) {
        if (!button) return;

        try {
            // Zkontrolujeme, zda jsou všechna povinná pole vyplněna
            var form = button.closest('form');
            if (!form) return;

            var isEdit = document.querySelector('input[name="inline_edit[submit]"]');
            var storeCardInput = document.getElementById('invoice-item_add-store-card');
            var nameInput = document.getElementById('invoice-item-name');
            var countInput = isEdit ? document.querySelector('input[name="inline_edit[count]"]') : document.getElementById('invoice-item-count');
            // var priceInput = isEdit ? document.querySelector('input[name="inline_edit[price]"]') : document.getElementById('invoice-item-price');

            // Kontrola povinných polí
            if (!isEdit && storeCardInput && !storeCardInput.value) {
                console.error('Chybí ID skladové karty');
                return;
            }

            if (!isEdit && nameInput && !nameInput.value) {
                console.error('Chybí název produktu');
                return;
            }

            if (countInput && (!countInput.value || parseInt(countInput.value, 10) <= 0)) {
                console.log('Nastavit výchozí hodnotu');
                countInput.value = '1'; // Nastavit výchozí hodnotu
            }

            // if (priceInput && (!priceInput.value || parseFloat(priceInput.value) <= 0)) {
            //     console.error('Chybí cena produktu');
            //     return;
            // }

            // Aktualizace ceny před odesláním
            this.updateInvoiceItemPrice();

            // Zkusit odeslat formulář pomocí NAJA frameworku
            // if (typeof naja !== 'undefined') {
            //     var formData = new FormData(form);
            //     var action = form.getAttribute('action') || window.location.href;
            //
            //     // Přidat hodnotu tlačítka do odesílaných dat
            //     formData.append(button.name, button.value);
            //
            //     // Odeslat formulář pomocí NAJA
            //     naja.makeRequest('POST', action, formData, {
            //         history: false,
            //         responseType: 'document'
            //     }).then(response => {
            //         // Po úspěšném odeslání aktualizovat grid
            //         var grid = document.querySelector('[id$="-grid"]');
            //         if (grid) {
            //             // Aktualizovat grid
            //             naja.snippetHandler.updateSnippets(response.snippets);
            //         }
            //     }).catch(error => {
            //         console.error('Chyba při odesílání formuláře:', error);
            //         // Záložní metoda - standardní kliknutí na tlačítko
            //         button.click();
            //     });
            // } else {
            // Záložní metoda - standardní kliknutí na tlačítko
            setTimeout(() => {
                button.click();
            }, 300);
            // }
        } catch (error) {
            console.error('Chyba při simulaci odeslání formuláře:', error);
            // Záložní metoda - standardní kliknutí na tlačítko
            button.click();
        }
    }


// Upravíme metodu checkCountAndCountAvailable pro ošetření sériových čísel
    checkCountAndCountAvailable() {
        if (this.invoiceItemCount && this.invoiceItemCountAvailable) {
            var count = parseInt(this.invoiceItemCount.value, 10);
            var countAvailable = parseInt(this.invoiceItemCountAvailable.value, 10);
            if (count && countAvailable >= 0 && count > countAvailable) {
                alert(`Není dostatek zboží skladem. Maximální počet je ${countAvailable}.`);
                return false;
            }
        }

        // Kontrola sériového čísla
        var serialNumberInput = document.getElementById('invoice-item-serial-number');
        if (serialNumberInput && !serialNumberInput.disabled && (!serialNumberInput.value || serialNumberInput.value.trim() === '')) {
            // Pokud je požadováno sériové číslo, ale není zadáno, zobrazíme upozornění
            alert('Prosím vyplňte sériové číslo.');

            // Použití setTimeout pro zajištění, že se focus nastaví až po zpracování alertu
            setTimeout(() => {
                serialNumberInput.focus();

                // Pokud je použitý NAJA framework, můžeme zkusit zablokovat jeho zpracování
                // tím, že odebereme data-atributy, které používá pro identifikaci cílů
                var addButton = document.querySelector('input[name="inline_edit[submit]"]');
                if (!addButton) {
                    addButton = document.querySelector('input[name="inline_add[submit]"]');
                }
                if (submitButton) {
                    var originalType = submitButton.type;
                    // Dočasně změníme typ tlačítka, aby se nezpracovalo jako submit
                    submitButton.type = 'button';
                    setTimeout(() => {
                        // A po krátké prodlevě jej vrátíme zpět
                        submitButton.type = originalType;
                    }, 100);
                }
            }, 0);

            return false;
        }

        var storeCardId = document.getElementById('invoice-item_add-store-card')?.value;
        if (!storeCardId || storeCardId === '') {
            this.showAddProductModal();
            return false;
        }

        return true;
    }



    createSuggestionsContainer() {
        var container = document.createElement('div');
        container.id = 'suggestions-container';
        container.classList.add('list-group');
        container.classList.add('ignore-form-dialog');
        container.style.position = 'absolute';
        container.style.zIndex = '9999';
        container.style.height = '35vh';
        document.body.appendChild(container);
        return container;
    }

    loadSuggestions(ignoreSameQuery = false) {
        clearTimeout(this.debounceTimer);
        this.debounceTimer = setTimeout(() => {
            var query = this.invoiceItemNameInput.value;
            var provide = this.invoiceItemNameInput.getAttribute('data-provide');

            if (query.length <= 2 || (!ignoreSameQuery && query === this.lastQuery) || this.isLoading) return;

            this.lastQuery = query;
            this.isLoading = true;
            if (this.activeRequest) this.activeRequest.abort();

            this.invoiceItemNameInput.classList.add('loading');

            var inputRect = this.invoiceItemNameInput.getBoundingClientRect();
            this.suggestionsContainer.style.top = `${inputRect.bottom + window.scrollY}px`;
            this.suggestionsContainer.style.left = `${inputRect.left + window.scrollX}px`;
            this.suggestionsContainer.style.width = `${inputRect.width * 4}px`;

            this.activeRequest = naja.makeRequest('POST', provide, {query}, {history: false})
                .then(response => {
                    this.displaySuggestions(response, query);
                })
                .finally(() => {
                    this.invoiceItemNameInput.classList.remove('loading');
                    this.isLoading = false;
                    this.activeRequest = null;
                });
        }, 300);
    }

    displaySuggestions(suggestions, query) {
        this.suggestionsContainer.innerHTML = '';
        this.suggestionsContainer.style.display = 'flex';

        Object.entries(suggestions).forEach(([id, product]) => {
            var item = document.createElement('a');
            item.classList.add('list-group-item', 'list-group-item-action');
            item.innerHTML = this.highlightMatch(product.name, query);

            // Přidání událostí pro hover a stylování
            item.addEventListener('mouseenter', () => {
                // Odstraníme zvýraznění ze všech položek
                this.suggestionsContainer.querySelectorAll('.list-group-item').forEach(el => {
                    el.classList.remove('highlighted');
                    el.style.background = '#fff';
                });

                // Zvýrazníme aktuální položku
                item.classList.add('highlighted');
                item.style.background = '#f0f0f0';
            });

            item.addEventListener('mouseleave', () => {
                if (!item.classList.contains('highlighted')) {
                    item.style.background = '#fff';
                }
            });

            item.addEventListener('click', () => {
                var itemName = document.getElementById('invoice-item-name');
                if (itemName) {
                    itemName.value = product.name;
                }
                var storeCard = document.getElementById('invoice-item-store-card');
                if (storeCard) {
                    storeCard.value = id;
                }

                // Zbývající kód zůstává stejný...
                var storeCardAdd = document.getElementById('invoice-item_add-store-card');
                if (storeCardAdd) {
                    storeCardAdd.value = id;
                }
                var itemPricePurchase = document.getElementById('invoice-item-price-purchase');
                if (itemPricePurchase) {
                    itemPricePurchase.value = product.pricePurchase;
                }
                var itemPrice = document.getElementById('invoice-item-price');
                if (itemPrice) {
                    itemPrice.value = product.priceSale;
                }
                var itemMeasure = document.getElementById('invoice-item-measure');
                if (itemMeasure) {
                    itemMeasure.value = product.measure;
                }
                var itemCatalog = document.getElementById('invoice-item-catalog');
                if (itemCatalog) {
                    itemCatalog.value = product.catalog;
                }
                var itemInternalNumber = document.getElementById('invoice-item-internal-number');
                if (itemInternalNumber) {
                    itemInternalNumber.value = product.internalNumber;
                }

                var itemSerialNumber = document.getElementById('invoice-item-serial-number');
                if (itemSerialNumber) {
                    if (product.serialNumbers) {
                        itemSerialNumber.removeAttribute('disabled');
                    } else {
                        itemSerialNumber.setAttribute('disabled', 'disabled');
                    }
                }

                if (this.invoiceItemCountAvailable) {
                    this.invoiceItemCountAvailable.value = product.countAvailable;
                }

                if (this.invoiceItemFees) {
                    var fee = parseFloat(product.feeRecycle) + parseFloat(product.feeCopyright);
                    if (!isNaN(fee)) {
                        fee = 0;
                    }
                    this.invoiceItemFees.value = fee.toFixed(2);
                }

                if (this.invoiceItemPriceSaleTax) {
                    this.invoiceItemPriceSaleTax.value = product.priceSaleTax;
                }

                if (this.invoiceItemPriceSale) {
                    var price = parseFloat(product.priceSale) * (1 + parseFloat(product.priceSaleTax) / 100);
                    this.invoiceItemPriceSale.value = price.toFixed(2);
                }

                this.invoiceItemCount.value = 1;
                this.updateInvoiceItemPrice();

                this.suggestionsContainer.innerHTML = '';
                this.suggestionsContainer.style.display = 'none';

                this.invoiceItemCount.select();


                this.invoiceItemEditInput = document.getElementById('invoice-item-edit');
                if (this.invoiceItemEditInput) {
                    this.invoiceItemEditInput.disabled = false;

                    this.invoiceItemEditInput.addEventListener('click', (e) => {
                        if (this.invoiceItemEditInput.disabled) return;

                        e.preventDefault();

                        var link = this.invoiceItemEditInput.getAttribute('data-link');
                        if (link) {
                            var storeCardId = document.getElementById('invoice-item_add-store-card').value;
                            var updatedLink = link.replace('ITEM_ID', storeCardId);
                            naja.makeRequest('GET', updatedLink, null, {
                                history: false
                            }).then(() => {
                                var modal = document.getElementById('modal-store-catalog-edit-info');
                                if (modal) {
                                    var bsModal = new bootstrap.Modal(modal);
                                    bsModal.show();
                                }
                                this.initModalEvents(modal, storeCardId);
                            });
                        }

                    });
                }
            });

            this.suggestionsContainer.appendChild(item);
        });
    }

    highlightMatch(text, query) {
        return text.replace(new RegExp(`(${query})`, 'gi'), '<strong>$1</strong>');
    }

    updateDateMaturity() {
        var dateIssue = new Date(this.dateIssueInput.value);
        var maturity = parseInt(this.maturityInput.value, 10);

        if (!isNaN(dateIssue.getTime()) && !isNaN(maturity)) {
            dateIssue.setDate(dateIssue.getDate() + maturity);
            this.dateMaturityInput.value = dateIssue.toISOString().split('T')[0];
        }
    }

    updateMaturity() {
        var dateIssue = new Date(this.dateIssueInput.value);
        var dateMaturity = new Date(this.dateMaturityInput.value);

        if (!isNaN(dateIssue.getTime()) && !isNaN(dateMaturity.getTime())) {
            var diffDays = Math.ceil((dateMaturity - dateIssue) / (1000 * 60 * 60 * 24));
            this.maturityInput.value = diffDays;
        }
    }

    updateInvoiceItemPrice(newCount = null) {
        var isEdit = document.querySelector('input[name="inline_edit[submit]"]');
        console.log('isEdit');
        var row = isEdit ? document.querySelector('input[name="inline_edit[submit]"]').closest('tr') : document.querySelector('input[name="inline_add[submit]"]').closest('tr');
        console.log(row);

        this.invoiceItemRepayment = row.querySelector('#invoice-item-repayment');
        this.invoiceItemCount = row.querySelector('#invoice-item-count');
        this.invoiceItemTaxRate = row.querySelector('#invoice-item-tax-rate');
        this.invoiceItemPrice = row.querySelector('#invoice-item-price');
        this.invoiceItemDiscount = row.querySelector('#invoice-item-discount');
        this.invoiceItemPriceBase = row.querySelector('#invoice-item-price-base');
        this.invoiceItemPricePurchase = row.querySelector('#invoice-item-price-purchase')
        this.invoiceItemPricePurchaseBase = row.querySelector('#invoice-item-price-purchase-base');
        this.invoiceItemPriceSale = row.querySelector('#invoice-item-price-sale');
        this.invoiceItemPriceSaleTax = row.querySelector('#invoice-item-price-sale-tax');
        this.invoiceItemPriceSaleTotal = row.querySelector('#invoice-item-price-sale-total');
        this.invoiceItemPriceTotal = row.querySelector('#invoice-item-price-total');
        this.invoiceItemCountAvailable = row.querySelector('#invoice-item-count-available');
        this.invoiceItemFees = row.querySelector('#invoice-item-fees');

        var itemCount = this.invoiceItemCount ? parseInt(this.invoiceItemCount.value, 10) : 1;
        if(newCount !== null) {
            itemCount = newCount;
            this.invoiceItemCount.value = itemCount;
        }

        var taxRate = this.invoiceItemTaxRate ? parseInt(this.invoiceItemTaxRate.value, 10) : 0;
        var price = this.invoiceItemPrice ? parseFloat(this.invoiceItemPrice.value) : 0;
        var priceSale = this.invoiceItemPriceSale ? parseFloat(this.invoiceItemPriceSale.value) : 0;
        var discount = this.invoiceItemDiscount ? parseFloat(this.invoiceItemDiscount.value) || 0 : 0;

        if (!isNaN(itemCount) && !isNaN(taxRate) && !isNaN(price)) {
            var priceBase = itemCount * price;
            var priceTotal = priceBase * (1 + taxRate / 100) * (1 - discount / 100);

            if (this.invoiceItemPriceBase) {
                this.invoiceItemPriceBase.value = priceBase.toFixed(2);
            }
            if (this.invoiceItemPriceTotal) {
                this.invoiceItemPriceTotal.value = priceTotal.toFixed(2);
            }
            if (this.invoiceItemPricePurchaseBase) {
                this.invoiceItemPricePurchaseBase.value = (itemCount * parseFloat(this.invoiceItemPricePurchase.value)).toFixed(2);
            }
        }

        if (!isNaN(itemCount) && !isNaN(priceSale)) {
            var priceSaleTotal = (itemCount * priceSale) * (1 - discount / 100);
            if (this.invoiceItemPriceSaleTotal) {
                this.invoiceItemPriceSaleTotal.value = priceSaleTotal.toFixed(2);
            }
        }
    }

    initModalEvents(modal, storeCardId) {
        // if (window.najaModalListenerInitialized) {
        //     return;
        // }
        //
        // window.najaModalListenerInitialized = true;
        modal.addEventListener('hidden.bs.modal', () => {
            var link = modal.getAttribute('data-link');
            link = link.replace('ITEM_ID', storeCardId);
            naja.makeRequest('GET', link, null, {
                history: false
            }).then((payload) => {
                var storeCard = payload.storeCard;
                var storeCardId = document.getElementById('invoice-item_add-store-card')?.value;

                if (storeCard && typeof storeCard !== 'undefined' && storeCardId && storeCard.id == storeCardId) {
                    if (this.invoiceItemNameInput.value !== storeCard.name) {
                        this.invoiceItemNameInput.value = storeCard.name;
                    }

                    this.invoiceItemPricePurchase.value = storeCard.purchasePrice;
                    this.updateInvoiceItemPrice();
                }
            });
        });
    }

    static initialize() {
        if (InvoiceForm.instance) {
            // Optionálně můžeš zkontrolovat, zda je potřeba znovu navázat (např. nový DOM prvek)
            return;
        }
        new InvoiceForm();
    }

    static reset() {
        InvoiceForm.instance = null;
    }
}

document.addEventListener('DOMContentLoaded', () => new InvoiceForm());

naja.addEventListener('complete', () => {
    new InvoiceForm(); // připojí se pouze na nově vytvořené prvky
});

document.addEventListener('datagrid-inline-add-open', () => {
    new InvoiceForm();
});

export default InvoiceForm;
